import { TYPES_CONFIG } from '../constants';
export var setDefaultValue = function setDefaultValue(property, operator) {
  var operatorSettings = TYPES_CONFIG[property];
  var defaultValue = operatorSettings[operator].defaultValue;

  if (typeof defaultValue === 'function' && {}.toString.call(defaultValue) === '[object Function]') {
    return defaultValue();
  }

  return defaultValue;
};